import { useSelector } from 'react-redux'
import {
  selectPerformanceDataItem,
  selectPerformanceDataTable,
} from '../store/slice'
import { ChartContent } from './ChartContent'
import { TableContent } from './tableContent'

export const PerformanceScore = () => {
  const data = useSelector(selectPerformanceDataTable)

  return (
    <div className="dFlex h100">
      <div className="flex1">
        <TableContent getDataFromRedux={selectPerformanceDataItem} />
      </div>

      <div style={{ width: 350, marginLeft: 36 }}>
        <ChartContent dataChart={data} />
      </div>
    </div>
  )
}
